export type Duration = {
	start: number
	end?: number
}

export interface LiveUserData {
	id: string
	name: string
	email: string | undefined
	position: number[]
	avatarImageUrl: string | undefined
}

export enum UserUpdateType {
	Init,
	Change,
	Delete,
}

export type UserUpdateInit = {
	type: UserUpdateType.Init
	users: Record<string, LiveUserData>
}

export type UserUpdateChange = {
	type: UserUpdateType.Change
	users: Record<string, LiveUserData>
}

export type UserUpdateDelete = {
	type: UserUpdateType.Delete
	id: string
}

export type UserUpdate = UserUpdateInit | UserUpdateChange | UserUpdateDelete

export interface User {
	id: string
	email: string
	name: string
	avatarUrl?: string
	creationDate: Date
	createdFirstSpace: boolean
	// True if the user is associated with the Co³Learn AcademicCloud organization
	isAcademicCloudUser?: boolean
}
